<app-select-multiple 
    [(ngModel)]="values"
    [label]="label"
    [options]="options"
    [loading]="loading"
    [id]="id"
    [showFilter]="true"
    #selectMultiple
></app-select-multiple>